// @core/api/endpoints/workflow/duplicate_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DuplicatePipelineRequest,
  PipelineResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Duplicate pipeline
 * Creates a copy of a pipeline with all nodes and connections. The copy is created in draft status.
 */
export async function DuplicatePipeline(
  pipeline_id: string,
  data: DuplicatePipelineRequest,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/duplicate`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<PipelineResponse>(requestPath, data, requestOptions);
}
